import "core-js/modules/es.object.assign.js";
import { getUrlParams } from './utils';
import { getCookie } from './cookies';
export var wxAuth = function wxAuth(conf) {
  var config = Object.assign({}, window.nativeAdapterConfig);
  window.wx.config({
    debug: config.debug || false,
    appId: conf.appId,
    timestamp: conf.timestamp,
    nonceStr: conf.noncestr,
    signature: conf.signature,
    jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareQZone', 'onMenuShareWeibo', 'scanQRCode', 'chooseImage', 'uploadImage', 'previewImage', 'getLocation', 'openLocation', 'launchApplication', 'getInstallState', 'openBusinessView']
  });
  window.wx.error(function (res) {
    console.error('微信配置失败', res);
  });
};
export var getWxPublicId = function getWxPublicId(_ref) {
  var isWa = Object.assign({}, _ref);
  var query = getUrlParams();
  var config = Object.assign({}, window.nativeAdapterConfig);

  if (isWa) {
    return query.wxPublicId || config.wxPublicId || '24';
  }

  return query.wxPublicId || config.wxPublicId || query.__t || getCookie('zz_t') || getCookie('t') || '24';
};